import styled from "styled-components";

export const InfoBubbleTooltipTrigerBox = styled.img`
        position: relative;
        z-index: 5;

        cursor: pointer;

        height: 2rem;
        width: 2rem;
`;